<template>
    <div>
        <div class="common_banner">
            <h3 class="title">专业团队研发</h3>
            <p class="subtitle">跳转代理提供电脑、手机、平板端，总有一款适合您</p>
        </div>
        <div class="container">
            <div class="iphone">

            </div>
            <div class="version">
                <h3 class="title">立即下载</h3>
                <p class="subtitle">满足您业务的多样性和无限的可能性</p>
                <ul ref="products">
                    <!-- <li class="item">
                        <a href="https://cdn.huashengdaili.com/huashengdaili1.3.0.exe" class="show">
                            <img src="@/assets/img/download_img/download_icon_windows.png" alt="">
                            <p class="tile">Windows端</p>
                            <div class="noshow">
                               <img class="no_img" src="~@/assets/img/index_img/download_icon_pc.png" alt="">
                               <p>点击下载Windows端</p>
                               <button>立即下载</button>
                            </div>
                        </a>
                    </li> -->
                    <!-- 推广 -->
                    <li class="item">
                        <a href="https://cdn.huashengdaili.com/huashengdaili_zdgs_1.4.5.exe" ref="pc" class="show">
                            <img src="@/assets/img/download_img/download_icon_windows.png" alt="">
                            <p class="tile">Windows端</p>
                            <div class="noshow">
                               <img class="no_img" src="~@/assets/img/index_img/download_icon_pc.png" alt="">
                               <p>点击下载Windows端</p>
                               <button>立即下载</button>
                            </div>
                        </a>
                    </li>
                    <li class="item">
                        <a href="https://itunes.apple.com/cn/app/%E8%8A%B1%E7%94%9F%E4%BB%A3%E7%90%86/id1367038214?mt=8" ref="ios" class="show">
                            <img src="@/assets/img/download_img/download_icon_iOS.png" alt="">
                            <p class="tile">iOS端</p>
                            <div class="noshow">
                              <img class="no_img" src="~@/assets/img/index_img/ios_wechat.png" alt="">
                              <p>扫描二维码下载iOS端</p>
                              <button>立即下载</button>
                            </div>
                        </a>
                    </li>
                    <!-- <li class="item">
                        <a href="https://cdn.huashengdaili.com/earthnutproxy_huashengdaili_v1.0.20.apk" class="show">
                            <img src="@/assets/img/download_img/download_icon_android.png" alt="">
                            <p class="tile">Android端</p>
                            <div class="noshow">
                               <img class="no_img" src="~@/assets/img/index_img/android_wechat.png" alt="">
                               <p>扫描二维码下载Android端</p>
                               <button>立即下载</button>
                            </div>
                        </a>
                    </li> -->
                     <li class="item">
                        <a href="https://cdn.huashengdaili.com/earthnutproxy_tiaozhuan_v1.0.37.apk" ref="android" class="show">
                            <img src="@/assets/img/download_img/download_icon_android.png" alt="">
                            <p class="tile">Android端</p>
                            <div class="noshow">
                               <img class="no_img" src="~@/assets/img/index_img/android_wechat.png" alt="">
                               <p>扫描二维码下载Android端</p>
                               <button>立即下载</button>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import doPost from "@/pages/Helper/XHR.js"
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      channel1: 'huashengdaili',
      channel2: 'tiaozhuan'
    }
  },
  mounted () {
    this.download();
    this.productsLink();
  },
  methods: {
    download () {
      var items =  this.$refs.products.getElementsByClassName('item')
      var _this = this
      for(let i=0;i<items.length;i++){
        items[i].addEventListener('click',() => {
          if(items[i].innerHTML.match('Android')){
            this.type = 'android'
          }else if(items[i].innerHTML.match('Windows')){
            this.type = 'pc'
          }else{
            this.type = 'ios'
          }
          let promise = new Promise((resolve,reject) => {
              doPost(
              {action:'download', ip:returnCitySN["cip"], type:this.type, channel:this.channel2, keyword: Cookies.get('keyword')},
              (data) => {
                if(data.status==200){
                    console.log(data)
                    resolve(data)
                }
              }
            )
          })
          promise.then(function(data){
            console.log(_this)
            console.log(_this.type)
            if(data.status==200){
              doPost(
                {action:'download_keyword', ip:returnCitySN["cip"], domain: Cookies.get('domain'), type: _this.type, channel:_this.channel2, keyword: Cookies.get('keyword'), domain_keyword: `${Cookies.get('domain')}${Cookies.get('keyword')}` },
                (data) => {
                 console.log(data)
                }
              )
            }
          })
        })
      }
    },
    productsLink () {
      doPost({action: 'channel_download',channel: this.channel2},
        (res) => {
          if(res.status == '200'&&res.detail) {
            let data = res.data;
            let pc = data.pc ? data.pc : '';
            let ios = data.ios ? data.ios : '';
            let android = data.android ? data.android : '';
            if(pc) {
              this.$refs.pc.href = pc;
              console.log(this.$refs.pc.href)
            }
            if(ios) {
              this.$refs.ios.href = ios;
              console.log(this.$refs.ios.href)
            }
            if(android) {
              this.$refs.android.href = android;
              console.log(this.$refs.android.href)
            }
          }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.common_banner
    background-image url("~@/assets/img/download_img/download_banner.png")
.container
    width 1200px
    margin 0px auto
    margin-top 110px
    margin-bottom 153px
    &:after
        content ''
        display block
        clear both
.container .iphone
    width 173px
    height 320px
    background  url("~@/assets/img/download_img/iphone.png")
    float left
    margin-left 60px
.container .version
    float left
    padding 17px 0px 0 120px
.container .version .title
    font-family MicrosoftYaHei
    font-size 18px
    color #333333
    letter-spacing 0.82px
.container .version .subtitle
    font-family MicrosoftYaHei
    font-size 14px
    color #666666
    letter-spacing 0.64px
    margin-top 20px
    margin-bottom 20px
.container .version ul li
    width 200px
    height 200px
    border-radius 4px
    border 1px solid #CCCCCC
    float left
    margin-right 40px
    position relative
    .noshow
      width 100%
      height 100%
      position absolute
      top 0
      background-repeat no-repeat
      background-position 50% 50%
      background-size 100% 100%
      background-color #2BD3A0
      opacity 0
      transition all .36s ease
      .no_img
        margin-top 15px
        cursor default
      p
        padding-top 10px
      button
        margin-top 20px
        width 136px
        height 38px
        background #fff
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #2BD3A0;
        letter-spacing: 1.14px;
        text-align: center;
        border-radius 30px
        cursor pointer
.container .version ul li:nth-child(1)
    margin-right 40px
.container .version ul li:nth-child(1):hover .noshow, .container .version ul li:nth-child(2):hover .noshow, .container .version ul li:nth-child(3):hover .noshow
    opacity 1
.container .version ul li .show
    display flex
    flex-direction column
    justify-content center
    width 100%
    height 100%
    text-align center
    color #222222
.container .version ul li .show img
    width 90px
    height 90px
    margin 0 auto
// .container .version ul li .show p
//     display inline-block
//     padding 25px 0px
@media screen and (max-width: 1200px)
    .container
        text-align center
        width 100%
    .container .iphone
        display none
    .container .version
        float none
        padding 0px
        margin-bottom 20px
    .container .version ul
        display inline-block
        margin 0 auto
    .container .version ul li:nth-child(3)
        margin-right 0px
    .container .version ul:after
        content ''
        display block
        clear both
        height 1px
@media screen and (max-width: 456px)
    .container
        margin-top 16px
        margin-bottom 0px
    .container .version ul li
        float none
        margin-right 0px
        margin-bottom 20px
        width 3.8rem
        height 2.86rem
    .container .version ul li .show p
        padding 16px 0
    .container .version ul li:nth-child(1)
        margin-right 0px
    .container .version ul
        display block
        width 100%
    .container .version ul li
        width 28.78%
        display inline-block
        float left
        margin 0px 10px
    .container .version ul li .noshow
       display none
</style>





// WEBPACK FOOTER //
// src/pages/Download/Download.vue